import React, { createContext, memo, useContext } from "react";

const StandardsTableContext = createContext(null);

const StandardsTableProvider = memo(props => {
  const { children, value } = props;

  return (
    <StandardsTableContext.Provider value={value}>
      {children}
    </StandardsTableContext.Provider>
  );
});

StandardsTableProvider.displayName = "StandardsTableProvider";

const useStandardsTable = () => {
  return useContext(StandardsTableContext);
};

const useStandardsTableOutline = () => {
  const context = useContext(StandardsTableContext);
  return {
    gridProps: context?.gridProps || {},
    sideNavData: context?.sideNavData || [],
  };
};

export { StandardsTableProvider, useStandardsTable, useStandardsTableOutline };
